/*
 * mc-home.js — Home Manifesto (Editorial Cinético)
 *
 * Reveal on-scroll com progressive enhancement. O atributo
 * `html[data-mc-anim="ready"]` é setado inline no <head> (theme.liquid, só na
 * index) ANTES do primeiro paint quando IntersectionObserver é suportado e o
 * usuário não pediu reduced-motion — evitando flash. Este script apenas observa
 * os elementos `.mc-reveal` e adiciona `.is-inview` ao entrarem na viewport.
 *
 * Sem a flag `ready` (sem suporte / reduced-motion), o CSS mantém todo o
 * conteúdo visível e este script só garante o estado revelado como fallback.
 */
(function () {
  'use strict';

  var els = document.querySelectorAll('.mc-reveal');
  if (!els.length) return;

  var ready = document.documentElement.getAttribute('data-mc-anim') === 'ready';

  // Sem IO ou sem flag: revela tudo imediatamente (conteúdo nunca fica oculto).
  if (!ready || !('IntersectionObserver' in window)) {
    for (var i = 0; i < els.length; i++) els[i].classList.add('is-inview');
    return;
  }

  var observer = new IntersectionObserver(
    function (entries, obs) {
      for (var j = 0; j < entries.length; j++) {
        var entry = entries[j];
        if (entry.isIntersecting) {
          entry.target.classList.add('is-inview');
          obs.unobserve(entry.target);
        }
      }
    },
    { rootMargin: '0px 0px -8% 0px', threshold: 0.1 }
  );

  for (var k = 0; k < els.length; k++) observer.observe(els[k]);
})();
